const registerFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  company: '',
  country: '',
  question: '',
  answer: '',
  termsConfirmed: false,
  captchaVerified: false
};

export default registerFormValues;



// WEBPACK FOOTER //
// ./src/containers/Register/registerFormValues.js